export default __webpack_public_path__ + "static/media/fon.09fc5aaf.png";